import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/AmusementServiceReserveFormTemplate`;


const ApiAmusementTemplate = {
  getAll: (params) => {
    const url = `${baseServiceUrl}/getAllAmusementServiceReserveFormTemplateByServiceId`;
    return ServiceApi.get(url, { params });
  },
  getDefault: (params) => {
    const url = `${baseServiceUrl}/getDefaultAmusementServiceReserveFormTemplate`;
    return ServiceApi.get(url, { params });
  },
  create: (params) => {
    const url = `${baseServiceUrl}/createOrEditAmusementServiceReserveFormTemplate`;
    return ServiceApi.post(url, params);
  },
  delete: (params) => {
    const url = `${baseServiceUrl}/deleteAmusementServiceReserveFormTemplate`;
    return ServiceApi.put(url, params);
  },
  deleteAll: (params) => {
    const url = `${baseServiceUrl}/deleteAllAmusementServiceReserveFormTemplate`;
    return ServiceApi.put(url, params);
  },
};

export default ApiAmusementTemplate;


